import { apiFetch } from "../../../services/api-fetch";
import Toast from "../../../components/modal/toast";
import SuggestBlock from "../../../components/suggest-block";
import { init as initSelect } from "../../../components/uic-select";
import { initSearchSelect } from "../../editors/utils/search-select";
import { init as initSlider } from "../../../components/uic-range";
import { triggerEvent } from "../../../services/helpers/trigger-event";

let directionTagData = null;

const subscribeOnVacancies = (url, data) => {
    return new Promise((res, rej) => {
        apiFetch(url, {
            method: "POST",
            body: data
        })
            .then(response => {
                submit.removeAttribute("data-loading", "");
                submit.disabled = false;
                if (response.success) {
                    Toast.open(response.message, {
                        state: "success"
                    });
                    res();
                } else {
                    console.error(response.error);
                    Toast.open(response.error, {
                        state: "error"
                    });
                    rej();
                }
            })
            .catch(error => {
                console.error(error);
                rej();
            })
    });
}

function initTagSelect(direction, pureTag) {
    if (!direction || !pureTag) {
        return;
    }

    const tagData = directionTagData;
    const tag = initSelect(pureTag);
    const tagContainer = pureTag.parentNode;

    function onDirectionUpdated() {
        const value = direction.value;
        const tags = tagData[value] || [];
        const hasTags = tags.length;

        tagContainer.classList.toggle("hide-select", !hasTags);
        tag.input.value = "";
        tag.clear();
        tags.forEach(([value, text]) => tag.add({ value, text }));
        pureTag.value = "";
    }

    direction.addEventListener("change", onDirectionUpdated);
    direction.addEventListener("select.change", onDirectionUpdated);
    onDirectionUpdated();
}

function initCitySelect(el) {
    if (!el) {
        return;
    }

    initSearchSelect(el, {
        dispatch(select, { cities }) {
            cities.forEach(({ name: value }) => select.add({ value }));
        }
    });
}

function getTagData() {
    const data = window.__tagData || [];
    const result = {};

    for (const { name, tags } of data) {
        result[name] = (tags || "").split(",").filter(i => i).map(pair => pair.split(":"));
    }

    delete window.__tagData;

    return result;
}

function initExperienceSelect(element) {
    if (!element) {
        return;
    }

    window.addEventListener("mousedown", (e) => {
        const closest = e.target.closest("[data-uic=select-like]");
        element.classList.toggle("opened", closest === element);
    });

    const formatter = (value) => {
        value = value | 0;

        if (value < 0) {
            return "Любой";
        }
        else if (value < 1) {
            return "< 1 года";
        }
        else if (value <= 10) {
            return value;
        }
        else {
            return "10+";
        }
    };
    const transformer = (value) => {
        if (value < 0) {
            return 100;
        }
        return parseInt(value);
    };
    const input = element.querySelector(".uic-select__input");
    const sliderElement = element.querySelector("[data-slider]");
    const slider = initSlider(sliderElement, {
        format: formatter,
        transformValue: transformer
    });

    slider.onUpdate((value) => {
        input.classList.remove("placeholder");
        input.value = formatter(value);
    });
    slider.onChange(() => triggerEvent(input, "change"));
}

onDomReady.then(() => {
    directionTagData = getTagData();
    SuggestBlock.init();
    document.querySelectorAll("select[name=direction]")
        .forEach((element) => {
            const tagsElement = element.parentElement.parentElement.querySelector("select[name='tags[]']");

            initTagSelect(element, tagsElement);
        });
    document.querySelectorAll("select[name=city]")
        .forEach(element => initCitySelect(element));

    document.querySelectorAll("[data-uic=select-like]").forEach(initExperienceSelect);
});

window.subscribeOnVacancies = subscribeOnVacancies;